import { action } from 'typesafe-actions';
import {AUTHENTICATE} from "./constants";

export const authenticate = (auth: any) => action(AUTHENTICATE, {auth});
